module.exports = __webpack_public_path__ + "static/media/gen_ai_necklace_main_wider_01.1d3ca037.png";